import React, { useEffect, useState } from "react";
import Header from "../../../component/Header";
import Sidebar from "../../../component/Sidebar";

const API_URL =  process.env.REACT_APP_API_URL;

export default function Expense() {
  const [expenses, setExpenses] = useState([]);
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");

  const filteredExpenses = Array.isArray(expenses)
    ? expenses.filter((e) => {
        const descMatch = e.description
          ?.toLowerCase()
          .includes(filterText.trim().toLowerCase());
        const dateValue = new Date(e.date);
        const startOk =
          !filterStartDate || dateValue >= new Date(filterStartDate);
        const endOk = !filterEndDate || dateValue <= new Date(filterEndDate);
        return descMatch && startOk && endOk;
      })
    : [];

  // Fetch expenses from backend
  const fetchExpenses = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/expenses`);
      const data = await res.json();

      // Ensure it’s always an array
      setExpenses(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching expenses:", err);
      setExpenses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  // Add new expense
  const addExpense = async (e) => {
    e.preventDefault();
    if (!description || !amount || !date || !type) {
      alert("Please fill all fields");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/expenses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ description, amount, date, type }),
      });

      if (!res.ok) throw new Error("Failed to add expense");

      const newExpense = await res.json();
      setExpenses([newExpense, ...expenses]);
      setDescription("");
      setType("");
      setAmount("");
      setDate("");
      fetchExpenses();
    } catch (err) {
      console.error(err);
      alert("Error adding expense");
    }
  };

  // Delete expense
  const deleteExpense = async (id) => {
    if (!window.confirm("Delete this expense?")) return;

    try {
      const res = await fetch(`${API_URL}/api/expenses/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Failed to delete");
      setExpenses(expenses.filter((e) => e.id !== id));
    } catch (err) {
      console.error(err);
      alert("Error deleting expense");
    }
  };

  const total = Array.isArray(filteredExpenses)
    ? filteredExpenses.reduce((sum, e) => sum + parseFloat(e.amount || 0), 0)
    : 0;
const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`; // Format as 'YYYY-MM-DD'
  };
  return (
    <>
      <Header />
      <Sidebar />
      <div className="min-h-screen bg-gray-100 p-6 flex flex-row justify-center pt-60 space-x-10">
        <div>
          <h1 className="text-3xl font-bold text-center mb-6">
            Expense Tracker
          </h1>

          {/* Total Card */}
          <div className="max-w-md mx-auto bg-white rounded-2xl shadow-md p-5 mb-6 text-center">
            <p className="text-gray-500 text-lg">Total Expense</p>
            <h2 className="text-3xl font-semibold text-gray-800">
              ${total.toFixed(2)}
            </h2>
          </div>

          {/* Form */}
          <form
            onSubmit={addExpense}
            className="max-w-md mx-auto bg-white p-6 rounded-2xl shadow-md space-y-4"
          >
          <select
              className="w-full border border-gray-300 rounded-lg p-2"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
                <option value="">Select Type</option>
                <option value="Office Supplies">Office Supplies</option>
                <option value="Office Rent">Office Rent</option>
                <option value="Travel">Travel</option>
                <option value="Meals">Meals</option>
                <option value="Salary">Salary</option>
                <option value="Miscellaneous">Miscellaneous</option>
            </select>
            <input
              type="text"
              placeholder="Description"
              className="w-full border border-gray-300 rounded-lg p-2"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <input
              type="number"
              placeholder="Amount"
              className="w-full border border-gray-300 rounded-lg p-2"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            <input
              type="date"
              className="w-full border border-gray-300 rounded-lg p-2"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Add Expense
            </button>
          </form>
        </div>

        <div>
          {/* Filter Controls */}
          <div className="max-w-md mx-auto mt-8 bg-white p-4 rounded-2xl shadow-md space-y-3">
            <h2 className="text-xl font-semibold text-gray-700 text-center">
              Filter Expenses
            </h2>
            <input
              type="text"
              placeholder="Search by description..."
              className="w-full border border-gray-300 rounded-lg p-2"
              onChange={(e) => setFilterText(e.target.value.toLowerCase())}
            />
            <div className="flex space-x-2">
              <input
                type="date"
                className="w-1/2 border border-gray-300 rounded-lg p-2"
                onChange={(e) => setFilterStartDate(e.target.value)}
              />
              <input
                type="date"
                className="w-1/2 border border-gray-300 rounded-lg p-2"
                onChange={(e) => setFilterEndDate(e.target.value)}
              />
            </div>
          </div>

          {/* Expense List */}
          <div className="max-w-md mx-auto mt-8 max-h-96 overflow-y-auto">
            {loading ? (
              <p className="text-center text-gray-500">Loading...</p>
            ) : !Array.isArray(filteredExpenses) ||
              filteredExpenses.length === 0 ? (
              <p className="text-center text-gray-500">No matching expenses.</p>
            ) : (
              <ul className="space-y-3">
                {filteredExpenses.map((e) => (
                  <li
                    key={e.id}
                    className="flex justify-between items-center bg-white p-4 rounded-xl shadow-sm"
                  >
                    <div>
                      <p className="font-semibold">{e.type}</p>
                      <p className="italic font-thin">{e.description}</p>
                      <p className="text-sm text-gray-500">{formatDate(e.date)}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-semibold text-gray-800">
                        ${parseFloat(e.amount).toFixed(2)}
                      </p>
                      <button
                        onClick={() => deleteExpense(e.id)}
                        className="text-red-500 text-sm mt-1 hover:underline"
                      >
                        Delete
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
